import constant from '../../store/constant'
import config from '../../store/config'
var utils = require('../../utils')

export default {
  name: 'clinic-edit',
  data: function () {
    return {
      utils: utils,
      shopId: null,
      isNewClinic: false,
      isDuplicate: false,
      changeDate: null,
      send_types: [],
      images: [],
      editImageTitle: '',
      clinic: {
        clinic_id: '',
        login_id: '',
        password: '',
        nsClinicCode: ''
      },
      history: {
        clinic_history_id: '',
        address1: '',
        address2: '',
        email: '',
        clinic_name: '',
        clinic_name_furigana: '',
        fax: '',
        map_lat: null,
        map_lng: null,
        map_zoom: null,
        post_no: '',
        send_timing: 0,
        send_timing_hour: '0.0',
        send_type: null,
        tel: '',
        fusezi_flag: false,
        start_date: '',
        end_date: ''
      },
      charge_shop_ids: [],
      searchCallbackFlag: false, // 検索結果フラグ
      isNsipsFlag: false,
    }
  },
  beforeRouteLeave (to, from, next) {
    utils.googleMapEventRemove()
    next()
  },
  created: function() {
    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.isNewClinic = utils.isBlank(this.$route.params.clinicHisId)
    if (!this.isNewClinic) {
      // 更新
      this.search()
    } else {
      // 新規

      // 送信タイプ
      this.history.send_timing = constant.clinic.default.send_timing
      this.history.send_timing_hour = constant.clinic.default.send_timing_hour

      // 自店舗デフォルト
      this.charge_shop_ids = [this.shopId]

      this.searchCallbackFlag = true
    }

    if(this.$router.currentRoute.query.nsips == 'clinic'){
      this.isNsipsFlag = true
      if (utils.isPresent(this.$router.currentRoute.query.clinic_code)) {
        var self = this
        var callback = function () {
          self.history.clinic_name = self.nsClinic.attributes['name-of-medical-institution']
          self.history.tel = self.nsClinic.attributes['medical-institution-telephone-number']
          self.clinic.nsClinicCode = self.nsClinic.attributes['medical-institution-reception-code']
        }
        this.$store.dispatch('NS_CLINIC_SEARCH', {
          data: { ns_clinic: this.$router.currentRoute.query.clinic_code },
          callback: callback
        })
      }
    }
  },
  mounted: function () {
    if (!this.isNewClinic) {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
    if (this.isNewClinic) {
      utils.googleMapEvent({
        js:           constant.js.google_maps,
        key:          config.google_map_api_key,
        mapElmId:     'map',
        lat:          null,
        lng:          null,
        zoom:         null,
        map_default:  constant.map_default,
        mapCallback:  this.mapCallback,
      })
    }
  },
  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    shops () {
      return this.$store.getters.shops.filter((o) => {
        return o.id != null
      })
    },
    /** 画像 */
    filteredImages () {
      return this.images.filter(function(item, index) {
        if (item.del_flag === 0) return true
      })
    },
    canAddImage () {
      return this.filteredImages.length < constant.place_image_upload_limit
    },
    notify() {
      return this.$store.getters.clinicNotify
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    sendTypes () {
      return this.$t('clinic.send_types')
    },
    sendTiming () {
      return this.$t('clinic.send_timing')
    },
    sendTimingHour () {
      return this.$t('clinic.send_timing_hour')
    },
    uploadCounter () {
      var total = this.$store.getters.imageUploadTotal
      var current = this.$store.getters.imageUploadCurrent
      if (total < 1 || total === current) {
        return ''
      } else {
        return this.$t('Count', {'Count': current + '/' + total}) + this.$t('Image Upload Successful')
      }
    },
    uploadErrors () {
      return this.$store.getters.imageUploadErrors
    },
    uploadSuccess () {
      return this.$store.getters.imageUploadStatus
    },
    required () {
      return {
        clinic_name:                  utils.isBlank(this.history.clinic_name),
        clinic_name_furigana_format:  !utils.isHiragana(this.history.clinic_name_furigana, false),
        post_no:                      utils.isBlank(this.history.post_no),
        post_no_format:               !utils.isPostNo(this.history.post_no),
        address1:                     utils.isBlank(this.history.address1),
        address2:                     utils.isBlank(this.history.address2),
        tel:                          utils.isBlank(this.history.tel),
        tel_format:                   !utils.isPhone(this.history.tel),
        fax:                          utils.isBlank(this.history.fax),
        fax_format:                   !utils.isPhone(this.history.fax),
        // email:                        utils.isBlank(this.history.email),
        email_format:                 !utils.isEmail(this.history.email),
        send_types:                   !(this.send_types.length > 0),
        charge_shop_ids:              !(this.charge_shop_ids.length > 0),
        change_date_format:           !utils.isWareki(this.$t, this.changeDate, true)
      }
    },
    isRequiredComplete () {
      var required = this.required
      return Object.keys(required).every(function (key) {
        return !required[key]
      })
    },
    nsClinic () {
      return this.$store.getters.ns_clinic
    }
  },
  methods: {
    search: function () {
      this.searchCallbackFlag = false
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('CLINIC_EDIT', {
        clinicHistoryId: this.$route.params.clinicHisId,
        data: { shop_id: this.shopId },
        callback: callback
      })
      .then(
        (res) => {this.callbackGetClinicData(res)},
        () => {this.goPrev()}
      )
    },
    callbackGetClinicData: function (data) {
      this.clinic = data.clinic
      this.history = data.clinic_history.data.attributes
      this.charge_shop_ids = data.charge_shop_ids
      this.send_types = utils.bitvalue2group(this.history.send_type, this.sendTypes)
      this.images = data.images

      // GoogleMaps 更新
      utils.googleMapEvent({
        js:             constant.js.google_maps,
        key:            config.google_map_api_key,
        mapElmId:       'map',
        lat:            this.history.map_lat,
        lng:            this.history.map_lng,
        zoom:           this.history.map_zoom,
        map_default:    constant.map_default,
        mapCallback:    this.mapCallback
      })
    },
    mapCallback: function(lat, lng, zoom) {
      this.history.map_lat = lat
      this.history.map_lng = lng
      this.history.map_zoom = zoom
    },
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type } })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query: { type: this.$router.currentRoute.query.type } })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type } })
    },
    goDoctorList: function () {
      var query = { type: this.$router.currentRoute.query.type}
      this.$router.push({ path: '/doctors', query: query })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query: { type: this.$router.currentRoute.query.type } })
    },
    goPrev: function () {
      if(this.$router.currentRoute.query.nsips == 'clinic'){
        this.$router.push({ path: '/nsips/clinics/list'})
      } else if (this.isNewClinic) {
        this.$router.push({path: '/clinics', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else {
        this.$router.push({path: '/clinics/' + this.$route.params.clinicId, query: {type: this.$router.currentRoute.query.type}})
      }
    },
    getReferenceDate: function () {
      if (this.history != null) {
        var start = this.utils.sereki2Wareki(this.$t, new Date(this.history.start_date))
        var end = new Date(this.history.end_date)
        if (end.getFullYear() == this.$t('history.max_year')) {
          end = this.$t('history.max_display')
        } else {
          end = this.utils.sereki2Wareki(this.$t, end)
        }
        return start + this.$t('history.delimiter') + end
      } else {
        return ''
      }
    },

    /** マーククリア */
    onClickMapMarkClear: function () {
      utils.googleMapEventMarkaClear()
      this.history.map_lat = null
      this.history.map_lng = null
      this.history.map_zoom = null
    },

    /** 郵便番号 */
    onChangePostNo: function () {
      if (!!this.history.post_no && utils.regex.post_no.test(this.history.post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.history.post_no, callback: (addr) => {
            if (addr !== null) {
              this.history.address1 = addr.address1
              this.history.address2 = addr.address2
              this.onChangeAddress()
            }
          }
        })
      }
    },

    /** 住所変更時イベント */
    onChangeAddress: function () {
      var arr = []
      if (utils.isPresent(this.history.post_no)) arr.push(this.history.post_no)
      if (utils.isPresent(this.history.address1)) arr.push(this.history.address1)
      if (utils.isPresent(this.history.address2)) arr.push(this.history.address2)
      if (arr.length > 0) {
        var address = arr.join(' ')
        if (window.googleMapsQuerySearch) {
          window.googleMapsQuerySearch(address)
        }
      }
    },

    /** 保存ボタン押下 */
    onClickSave: function () {
      if (!this.isRequiredComplete) {
        return
      }

      // 電話番号重複チェック
      this.$store.dispatch('CLINIC_DUPLICATE_CHECK', {
        data: {
          clinic_id: this.clinic.clinic_id,
          tel: this.history.tel
        },
        callback: (result) => {
          if (result) {
            var button = document.getElementById('duplicate_tel_modal_button')
            button.click() // モーダル表示 イベント発火
          } else {
            this.save()
          }
        }
      })
    },

    /** 保存 */
    save: function() {
      if (this.send_types) {
        this.history.send_type = utils.group2bitvalue(this.send_types)
      }
      var clinicId = null
      if (utils.isPresent(this.$route.params.clinicId)) {
        clinicId = this.$route.params.clinicId
      }
      var data = {
        clinic: {
          clinic_id:  clinicId,
          login_id:   this.clinic.login_id,
          password:   this.clinic.password,
          medical_institution_reception_code: this.clinic.nsClinicCode
        },
        clinic_history: {
          clinic_history_id:      this.history.clinic_history_id,
          address1:               this.history.address1,
          address2:               this.history.address2,
          email:                  this.history.email,
          enable_flag:            this.history.enable_flag,
          clinic_name:            this.history.clinic_name,
          clinic_name_furigana:   this.history.clinic_name_furigana,
          fax:                    this.history.fax,
          fusezi_flag:            this.history.fusezi_flag,
          map_lat:                this.history.map_lat,
          map_lng:                this.history.map_lng,
          map_zoom:               this.history.map_zoom,
          post_no:                this.history.post_no,
          send_timing:            this.history.send_timing,
          send_timing_hour:       this.history.send_timing_hour,
          send_type:              this.history.send_type,
          tel:                    this.history.tel
        },
        change_date:      this.isNewClinic ? "" : utils.wareki2Seireki(this.$t, this.changeDate, 'y-m-d'),
        charge_shop_ids:  this.charge_shop_ids,
        images:           this.images
      }

      this.$store.dispatch('CLINIC_SAVE', {data: data, callback: this.goPrev})
    },

    /** 画像アップロード */
    onUploadModal: function () {
      var button = document.getElementById('images_upload_modal_button')
      button.click() // モーダル表示 イベント発火
      this.uploadStart()
    },
    onDragOver: function (event) {
      var files = event.dataTransfer.items
      if (files && (files.length + this.filteredImages.length > constant.place_image_upload_limit)) {
        event.dataTransfer.dropEffect = "none"
      }
      event.preventDefault()
    },
    onDrop: function (event) {
      console.log('onDrop')
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault()

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.dataTransfer.files
      this.upload(files)
    },
    onFileChange: function (event) {
      console.log('onFileChange')

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files
      this.upload(files)
    },
    uploadStart: function () {
      this.$store.dispatch('UPLOAD_START')
    },
    upload: function (files) {
      if (!files)
        return
      if (files.length + this.filteredImages.length > constant.place_image_upload_limit)
        return
      for (var i=0; i<files.length; i++) {
        var formData = new FormData()
        formData.append('image_attach[cache_id]', files[i])
        this.$store.dispatch('IMAGE_UPLOAD', { data: formData, callback: this.onUpload })
      }
    },
    onUpload: function (data) {
      var img = {}
      img.id = null
      img.title = data.title
      img.image_attach_id = null
      img.cache_id = data.cache_id
      img.cache_id_cache = data.cache_id_cache
      img.image_path = data.image_path
      img.del_flag = 0
      this.images.push(img)
    },
    removeImage: function (img) {
      img.del_flag = 1
    },
    /** 画像押下 */
    onClickImageModalShow: function (image) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = image.image_path + '?token=' + this.authToken
      text.textContent = image.title
      button.click() // モーダル表示 イベント発火
    },
    /** 画像タイトルリンク */
    showImageTitleEditModal: function (image) {
      this.selectedImage = image
      this.editImageTitle = image.title
      this.$refs.editTitleBtn.click()
    },
    saveTitle: function () {
      this.selectedImage.title = this.editImageTitle
    },
    /** 画像登録ボタン */
    showUploadModal: function () {
      if (this.canAddImage) {
        this.$store.dispatch('IMAGE_UPLOAD_START', {})
        this.$refs.uploadBtn.click()
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/clinic-edit.js